// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ChartController from "./bookmark_chart_controller"
application.register("bookmark-chart", ChartController)

import DatagridController from "./datagrid_controller"
application.register("datagrid", DatagridController)

import StickyFooterController from "./sticky_footer_controller"
application.register("sticky-footer", StickyFooterController)

import PageProgressController from "./page_progress_controller"
application.register("page-progress", PageProgressController)

import DropzoneController from "./dropzone_controller"
application.register("dropzone", DropzoneController)

import DashboardLayoutController from "./dashboard_layout_controller"
application.register("dashboard-layout", DashboardLayoutController)
// import HelloController from "./hello_controller"
// application.register("hello", HelloController)
import MissionController from "./mission_controller"
application.register("mission", MissionController)

import IdentityPhotoController from "./identity_photo_controller"
application.register("identity-photo", IdentityPhotoController)

import AccreditationsFormController from "./accreditation_form_controller"
application.register("accreditation-form", AccreditationsFormController)

import AccreditationSearchController from "./accreditation_search_controller"
application.register("accreditation-search", AccreditationSearchController)

import VolunteerAvailabilityController from "./volunteer_availability_controller"
application.register("volunteer-availability", VolunteerAvailabilityController)

import ReportingController from "./reporting_controller"
application.register("reporting", ReportingController)

import AccreditationPreviewController from "./accreditation_preview_controller"
application.register("accreditation-preview", AccreditationPreviewController)

import EnrollmentHistoryPreviewController from "./enrollment_history_preview_controller"
application.register("enrollment-history-preview", EnrollmentHistoryPreviewController)

import ClickableRowController from "./clickable_row_controller"
application.register("clickable-row", ClickableRowController)

import InvestigationFormController from "./investigation_form_controller"
application.register("investigation-form", InvestigationFormController)

import SneasIdentifierController from "./sneas_identifier_controller"
application.register("sneas-identifier", SneasIdentifierController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import BadgeBatchProgressController from "./badge_batch_progress_controller"
application.register("badge-batch-progress", BadgeBatchProgressController)

import BadgeBatchGridController from "./badge_batch_grid_controller"
application.register("badge-batch-grid", BadgeBatchGridController)

import BadgeDistributionRecipientController from "./badge_distribution_recipient_controller"
application.register("badge-distribution-recipient", BadgeDistributionRecipientController)

import UserAbilitiesController from "./user_abilities_controller"
application.register("user-abilities", UserAbilitiesController)

import NavbarFlashController from "./navbar_flash_controller"
application.register("navbar-flash", NavbarFlashController)

//import EventsFormController from "./event_form_controller"
//application.register("event-form", EventsFormController)
